// Seeing Double (Mercury): a doubled letter, the same letter twice in a row,
// scores more on both its stars.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { lettersOf } from '../shared/letters';
import type { AlignmentDef } from '../types';

export const seeingDouble: AlignmentDef = {
  id: 'seeing-double',
  planet: 'mercury',
  name: 'Seeing Double',
  text: () => `Doubled letters score +${N.seeingDoublePercent}%.`,
  starPercent: (star, c) => {
    const letters = lettersOf(c.word);
    const l = letters[star.index];
    const doubled = letters[star.index - 1] === l || letters[star.index + 1] === l;
    return doubled ? N.seeingDoublePercent : 0;
  },
};
